import { Injectable } from '@angular/core';

import { DataQueryControllerService } from '@osos/shared/api';
import { FilterExpressionPresenterModel } from '@osos/shared/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class DataQueryService extends DataQueryControllerService {
  parseExpression(expression: FilterExpressionPresenterModel): Observable<any> {
    return this.criteriaParser({
      body: expression,
    }).pipe(map((res) => JSON.parse(res)));
  }
}
